<template>
  <PageHeader v-if="content && content.data" class="article-header" :image="content.data.image" :imageAlt="content.data.title">
    <div class="article-header__content mks-grid mks-grid-gap-xl">
      <div class="article-header__content-bubble">
        <Breadcrumbs :items="breadcrumbs"/><br>
        <LikeTopic :topic="topic">
          {{ topic.title }}
        </LikeTopic>
        <div v-if="content">
          <mks-heading tag="h1" class="article-header__title">
            <span v-html="content.data.title"></span>
          </mks-heading>
          <mks-text color="light" tag="div">{{ content.data.descriptionCourte }}</mks-text>
        </div>
        <!-- <mks-link to="/media/selection/cyril-dion" class="article-header__selection" type="menu">
          <mks-avatar class="selection__avatar"/>
          <div class="selection__text">
            <mks-text tag="p" weight="bold">Article sélectionné par Cyril Dion</mks-text>
            <mks-text tag="p" color="light">Expert en transition écologique</mks-text>
          </div>
        </mks-link> -->
      </div>
    </div>
  </PageHeader>
</template>
<script>
export default defineNuxtComponent({
  name: 'ArticleHeader',
  props: {
    content: {
      required: true
    }
  },
  computed: {
    breadcrumbs() {
      return [
        {label: 'Accueil', path: '/'},
        {label: this.topic.title, path: this.linkToTopic},
        {label: this.content.data.title.replaceAll('&nbsp;', '').replaceAll('<br>', '').replaceAll('<br/>', '')},
      ]
    },
    topic() {
      if (!this.content || !this.content.data) return;
      return this.content.data.thematique.value.data;
    },
    author() {
      if (!this.content || !this.content.data || !this.content.data.auteurice) return;
      return this.content.data.auteurice.value.data;
    },
    linkToTopic() {
      return '/media/'+ this.topic.slug
    }
  },
  
})
</script>
<style lang="scss">
.article-header {

  @include breakpoint('small', 'max') {
      margin-bottom: 200px;
    }

  &__content {
    @include breakpoint('small', 'max') {
      display: block;
      position: relative;
      top: 200px;
    }
  }

  &__title {
    margin-bottom: $space-xs;
    overflow-wrap: anywhere;

    @include breakpoint('small', 'max') {
      font-size: $font-size-xxxl !important;
    }
  }

  &__content-bubble {
    z-index: 1;
    background: $color-neutral-100;
    padding: $space-l $space-l $space-xl;
    border-top-left-radius: $space-l;
    border-top-right-radius: $space-l;
    border-bottom-right-radius: $space-l;
    border-bottom-left-radius: 80px;
    border: $border;

    & > * {
      display: inline-block;
      margin-bottom: $space-m;
      &:last-child {
        margin-bottom: 0;
      }
    }

    @include breakpoint('small') {
      padding: $space-l $space-xl $space-xl;
      max-width: 585px;
      min-height: 330px;
      min-width: 440px;
    }
  }
}
.article-header__selection {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.selection__avatar {
  border-radius: 40px;
  width: 57px;
  height: 34px;
  margin-right: $space-s;
  margin-bottom: $space-xxs;
}
.selection__text {
  margin-bottom: $space-xxs;
}
</style>